import React, { useState } from 'react';
import {
  TableRow, TableCell,
  ListItem, ListItemText
} from '@material-ui/core';
import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { MUISelect, MUITextBox, ReactSelect } from 'components/FormHelpers/FormInputs';
import _ from 'lodash';
import { getUIDateFormat, getEmptyValue } from 'helpers';
import { MUIDatePicker } from 'components/FormHelpers/DatePicker';
import { compose, withHandlers } from 'recompose';
import { withAppContext } from '@ctsu/loader';
import { SiteSelector } from 'containers/protocol/components';
import { withChangeHandlers } from 'helpers/Change';

const AgentDeviceName = ({
  agentDeviceName, ctepAgents, handleChange
}) => (
  <MUISelect
    name="agentDeviceName"
    value={getEmptyValue(agentDeviceName)}
    onChange={handleChange}
    validators={['required']}
    errorMessages={['Required Field']}
    title="Agent Device Name"
  >
    {ctepAgents.map((opt, index) => (
      <ListItem
        button
        key={_.uniqueId('study_agents_ctepagents_sel')}
        value={opt.agent}
      >
        {opt.agent}
      </ListItem>
    ))}
  </MUISelect>
);
const INDIDEHolder = ({ indIdeHolder, handleChange }) => (
  <MUISelect
    name="indIdeHolder"
    value={getEmptyValue(indIdeHolder)}
    onChange={handleChange}
    validators={['required']}
    errorMessages={['Required Field']}
    title="INDIDEHolder"
  >
    <ListItem button value="Group">
      <ListItemText primary="Group" />
    </ListItem>
    <ListItem button value="Pharma">
      <ListItemText primary="Pharma" />
    </ListItem>
    <ListItem button value="Other">
      <ListItemText primary="Other" />
    </ListItem>
  </MUISelect>
);

const Groups = ({
  state, protocolAgentGroup, setState
}) => {
  const [agent, selAgent] = useState(null);
  const { indIdeHolderName } = state;
  const matches = protocolAgentGroup
    ? protocolAgentGroup.map(suggestion => ({
      value: suggestion,
      label: suggestion
    }))
    : undefined;

  const initValue = state && matches
   && _.find(matches, (item) => indIdeHolderName === item.value);

  return (
    <ReactSelect
      title="Ind/Ide Holder Name"
      name="indIdeHolderName"
      validators={['required']}
      errorMessages={['Required Field']}
      options={matches}
      value={agent || initValue}
      onChange={event => {
        selAgent(event);
        setState({ ...state, indIdeHolderName: event ? event.value : '' });
      }}
    />
  );
};

const Pharma = ({
  handleSiteChange, state
}) => (
  <SiteSelector
    name="indIdeHolderName"
    onChanged={handleSiteChange}
    orgTypeExp="^(DCY)$"
    validators={['required']}
    errorMessages={['Required Field']}
    selSite={state && state.indIdeHolderName}
    hideCtepIdInDropdown
  />
);

const IDENumber = ({ indIdeNumber, handleChange }) => (
  <MUITextBox
    title="IDE Number"
    value={getEmptyValue(indIdeNumber)}
    validators={indIdeNumber ? ['maxStringLength:50'] : []}
    errorMessages={['Maximum 50 characters allowed']}
    onChange={handleChange}
    name="indIdeNumber"
  />
);

const Other = ({ state, handleChange }) => (
  <MUITextBox
    title="Other"
    value={getEmptyValue(state && state.indIdeHolderName)}
    onChange={handleChange}
    validators={['required']}
    errorMessages={['Required Field']}
    name="indIdeHolderName"
  />
);

const StatusDate = ({
  esysStatusDate, handleDateChange
}) => (
  <MUIDatePicker
    title="Status Date"
    name="esysStatusDate"
    onChange={handleDateChange('esysStatusDate')}
    value={esysStatusDate ? getUIDateFormat(esysStatusDate) : ''}
  />
);

const Status = ({ esysStatus, handleChange }) => (
  <MUISelect
    name="esysStatus"
    value={esysStatus || 'ACTIVE'}
    onChange={handleChange}
    validators={['required']}
    errorMessages={['Required Field']}
    title="Status"
  >
    <ListItem button value="ACTIVE">
      <ListItemText primary="Active" />
    </ListItem>
    <ListItem button value="INACTIVE">
      <ListItemText primary="Inactive" />
    </ListItem>
  </MUISelect>
);

const SwitchAgentType = (type, props) => ({
  Group: <Groups {...props} />,
  Pharma: <Pharma {...props} />,
  Other: <Other {...props} />
})[type];

const EditIndAgents = (props) => {
  const {
    state,
    ctepAgents,
    handleChange,
    handleChangeIndHolder,
    handleDateChange,
    cancel,
    reset
  } = props;

  const {
    agentDeviceName,
    indIdeHolder,
    indIdeNumber,
    esysStatus,
    esysStatusDate,
    modifiedUser,
    modifiedDate
  } = state;


  return (
    <TableRow className="state">
      <TableCell>
        <AgentDeviceName
          agentDeviceName={agentDeviceName}
          ctepAgents={ctepAgents}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <INDIDEHolder
          indIdeHolder={indIdeHolder}
          handleChange={handleChangeIndHolder}
        />
      </TableCell>
      <TableCell className="disableOverflow">
        {SwitchAgentType(indIdeHolder, props)}
      </TableCell>
      <TableCell>
        <IDENumber
          indIdeNumber={indIdeNumber}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <Status
          esysStatus={esysStatus}
          handleChange={handleChange}
        />
      </TableCell>
      <TableCell>
        <StatusDate
          esysStatusDate={esysStatusDate}
          handleDateChange={handleDateChange}
        />
      </TableCell>
      <TableCell>{modifiedUser || ''}</TableCell>
      <TableCell>{modifiedDate || ''}</TableCell>
      <TableCell align='center'>
        <GridSubmitAction
          cancel={cancel}
          reset={reset}
        />
      </TableCell>
    </TableRow>
  );
};

const EditINDAgents = compose(
  withAppContext,
  withChangeHandlers,
  withHandlers({
    handleChangeIndHolder: props => event => {
      const { state, setState } = props;
      setState({
        ...state,
        [event.target.name]: event.target.value,
        indIdeHolderName: ''
      });
    }
  })
)(EditIndAgents);

export default EditINDAgents;
